<template>
    <v-toolbar text color="white">
        <v-form @submit="submitForm">
            <v-autocomplete
                v-model="select"
                :items="items"
                :loading="loading"
                :search-input.sync="search"
                solo
                text
                single-line
                text
                clearable
                color="black"
                hide-no-data
                hide-selected
                item-text="id"
                item-value="id"
                placeholder="Поиск по id заказа"
                prepend-icon="search"
                append-icon=""
                return-object/>
        </v-form>
    </v-toolbar>
</template>

<script>
    import Order from '../../../../api/order'

    export default {
        name: 'orderSearch',
        data: () => ({
            select: null,
            items: [],
            loading: false,
            search: null,
        }),
        methods: {
            editOrder (value) {
                let routerName

                switch (value.state) {
                    case 1:
                    case 3:
                    case 9:
                        routerName = 'editOrderForNew'
                        break
                    case 4:
                    case 5:
                    case 6:
                        routerName = 'editOrderForInProgress'
                        break
                    default:
                        routerName = 'editOrderForEnded'
                        break
                }

                this.$router.push({
                    name: routerName,
                    params: { orderId: value.id }
                })
            },
            searchById (id) {
                this.loading = true

                Order
                    .searchById({ id })
                    .then(response => this.items = response.data.data)
                    .catch(error => {
                        if (error && error.response.headers && error.response.status === 404) {
                            this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        }

                        this.select = null
                    })
                    .finally(() => this.loading = false)
            },
            submitForm (event) {
                event.preventDefault()

                this.searchById(this.search)
            }
        },
        watch: {
            select (value) {
                if (!value) return

                this.editOrder(value)
            },
            search (value) {
                if (!value || value === this.select) {
                    return false
                }
            }
        },
    }
</script>
